export default __webpack_public_path__ + "static/aware-e853f64e9ba4f519bc69c49d3fe0f376.png";